<template>
	<div>

		<div class="input-group mb-2">
			<input
				type="text"
				:placeholder="$t('search-ellipses')"
				v-model="search.q"
				class="form-control form-control-lg"
				@keyup.enter="getItems"
			/>
			<div class="input-group-append">
				<button class="btn btn-primary" type="button" @click="getItems">
					<b-icon icon="search"></b-icon>
				</button>
			</div>
			<button @click="addNew" class="btn btn-primary ml-3">
				{{ $t('new-procedure') }}
			</button>
		</div>

        <InfiniteScroll
			scrollElementId="main"
			type="Table"
			:cols="[{ key: 'caption', heading: $t('name'), size: 12 }]"
			breakpoint="sm"
			:dataUrl="dataUrl"
			dataProperty="results"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectItem"
			@deleteItem="deleteItem"
			ref="infinitescroll"
			:noResultsText="$t('no-results')"
			idProperty="id"
		/>

	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll"
export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			dataUrl: `${this.$settings.APIBaseURL}/procedures/procedures`,
			search: {
				q: ""
			}
		}
	},
	mounted() {
		this.getItems();
	},
	methods: {
		selectItem(item) {
			this.$router.push(`/settings/interfaceeditor/procedures/edit/${item.id}`);
		},
		deleteItem(item){
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/deleteprocedure`, {
				data: {
					id: item.id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$refs.infinitescroll.removeItem(item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getItems() {
			let body = {
				q: this.search.q
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		addNew() {
			this.$router.push(`/settings/interfaceeditor/procedures/edit`);
		}
	},
	computed: {

	}
};
</script>
